export var AccountRejectedIA = function AccountRejectedIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return ACCOUNT_REJECTED_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ACCOUNT_REJECTED_DESCRIPTION(strictLocalize)];
    }
  };
};
var ACCOUNT_REJECTED_TITLE = function ACCOUNT_REJECTED_TITLE(strictLocalize) {
  return strictLocalize({
    id: "SQcNcq",
    defaultMessage: "Account rejection"
  });
};
var ACCOUNT_REJECTED_DESCRIPTION = function ACCOUNT_REJECTED_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "x0nDyC",
    defaultMessage: "Unfortunately, at this time, we are unable to move forward with your account on Faire. All your pending orders will be canceled. If any orders have already shipped, your payouts will be issued accordingly. We are unable to provide further details at this time. We apologize for any inconvenience but thank you for your understanding."
  });
};